/* eslint-disable */

module.exports = {
  isValidAddress(address, currency, networkType) {
    return true;
  }
};
